const dataCards = [
    {
        title: 'Canais de Atendimento',
        desc: 'Central de atendimento exclusiva para clientes PME, além dos nossos canais digitais. Confira!',
        link: 'https://stgnovoportaldevsite.blob.core.windows.net/$web/canais_atendimento.pdf?sp=r&st=2021-10-22T15:00:26Z&se=2025-10-22T23:00:26Z&spr=https&sv=2020-08-04&sr=b&sig=N%2FABgwtYWYSCC480JHbzfR8sgyWwEY4U1IiVtRr2uAI%3D',
    },
    {
        title: 'Cartilha Explicativa - como aderir ao DAP',
        desc: 'Manual de orientação ao beneficiário demitido ou aposentado',
        link: 'https://stgnovoportaldevsite.blob.core.windows.net/$web/cartilha_dap_2015.pdf?sp=r&st=2021-10-22T15:04:51Z&se=2025-10-22T23:04:51Z&spr=https&sv=2020-08-04&sr=b&sig=5KIjoF2yb9GCMl5gu2ajNV8s%2Fm%2B863PtAiVn%2BGwlYcs%3D',
    },
    {
        title: 'Declaração para Opção de Continuidade',
        desc: 'Termo de opção de continuidade ao beneficiário demitido ou aposentado',
        link: 'https://stgnovoportaldevsite.blob.core.windows.net/$web/Declara%C3%A7%C3%A3o%20para%20Op%C3%A7%C3%A3o%20de%20Continuidade.pdf?sp=r&st=2022-04-18T14:46:54Z&se=2029-04-18T22:46:54Z&spr=https&sv=2020-08-04&sr=b&sig=fR1By6cQmGJfCJDGz8MSkgVK00Ek21ZC4cs7RfV4fhA%3D',
    },
    {
        title: 'Formulário RN 412',
        desc: 'Formulário de exclusão de beneficiário pela RN 412 ',
        link: 'https://stgnovoportaldevsite.blob.core.windows.net/$web/Formul%C3%A1rio%20exclus%C3%A3o%20de%20benefici%C3%A1rio%20pela%20RN%20412.pdf?sp=r&st=2021-12-06T16:24:52Z&se=2029-12-07T00:24:52Z&spr=https&sv=2020-08-04&sr=b&sig=iN1gAln2DDnjO6w7VWrPeHaOninSa0WADZx%2FjiYLvRo%3D',
    },
    {
        title: 'Manual FAQ - Dúvidas Pós-Vendas',
        desc: 'Material com as respostas para as perguntas mais frequentes',
        link: 'https://stgnovoportaldevsite.blob.core.windows.net/$web/faq_pos_venda.pdf?sp=r&st=2021-10-22T15:06:43Z&se=2025-10-22T23:06:43Z&spr=https&sv=2020-08-04&sr=b&sig=2F%2FUIJCf3IuPWtFMqZmzfT%2Fziz7nzH%2BY5g3TXyqMnF8%3D',
    },
    {
        title: 'Programa de Compliance',
        desc: 'Conjunto de valores relativos ao combate à prática de lavagem de dinheiro, corrupção em todas as suas formas, inclusive extorsão e propina',
        link: 'https://stgnovoportaldevsite.blob.core.windows.net/$web/programa_compliance.pdf?sp=r&st=2021-10-22T15:10:22Z&se=2025-10-22T23:10:22Z&spr=https&sv=2020-08-04&sr=b&sig=0YviYxMjgVSsUDTR9%2BHCIKBCD9wO5f9ogVI9%2FIyKbms%3D',
        cardPme: true,
    },
    {
        title: 'Termo de Proteção de Dados - LGPD',
        desc: 'Termo de adequação do contrato firmado entre as PARTES ao conforme normativo contido na Lei Geral de Proteção de Dados.',
        link: 'https://stgnovoportaldevsite.blob.core.windows.net/$web/termos_lgpd.pdf?sp=r&st=2021-10-22T15:12:10Z&se=2025-10-22T23:12:10Z&spr=https&sv=2020-08-04&sr=b&sig=Fbu3CRTVbkFsWfovpLG6%2FvK5%2BGWzJmCpftDioudXJa0%3D',
        cardPme: true,
    },
];

export default dataCards;
